/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Red_Known_Mongoose_ReadInputs */

const fr_red_known_mongoose_read = /** @type {(inputs: Red_Known_Mongoose_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez votre progression et consultez vos séances`)
};

/**

* @param {Red_Known_Mongoose_ReadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const red_known_mongoose_read = /** @type {((inputs?: Red_Known_Mongoose_ReadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Red_Known_Mongoose_ReadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_red_known_mongoose_read(inputs)
});